import React from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faPrint, faSearch } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../../../components/panelcontrols/panelbuttontable'
import DeleteButton from '../../../../../components/panelcontrols/paneltablebuttons/deletebutton'
import { toast } from 'react-toastify';
import Functions from '../functions';

const Index = ({List,setList,search,onSearch,setShowStatusEdit,setSelectedOrder,setSelectedStatus,setShowDepartmentEdit,setSelectedDepartment}) => {
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input
          value={search || ''}
          onChange={(e)=>onSearch(e.target.value)}
          placeholder='Search invoice, doctor, status, department...'
        />
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              <div className='_th' style={{width:"7%"}}>Invoice</div>
              <div className='_th' style={{width:"15%"}}>Client</div>
              <div className='_th' style={{width:"10%"}}>Status</div>
              <div className='_th' style={{width:"14%"}}>Department</div>
              <div className='_th' style={{width:"12%"}}>Due Date</div>
              <div className='_th' style={{width:"12%",textAlign:"end"}}>Net Total</div>
              <div className='_th' style={{width:"30%",textAlign:"end"}}>Actions</div>
            </div>
          </div>
          <div className='_tbody'>
            {List.length > 0 &&
              List.map((item,index)=>{
                return(
                  <div className='_tr'style={{padding:"5px 0px"}} key={index}>
                    <div className='_td' style={{width:"7%"}}>OR{item.id}</div>
                    <div className='_td' style={{width:"15%"}}>{item.doctorname}</div>
                    <div className='_td' style={{width:"10%"}}>{item.statusname}</div>
                    <div className='_td' style={{width:"14%"}}>{item.departmentname}</div>
                    <div className='_td' style={{width:"12%", backgroundColor:item.ordercolor}}>
                      {item.duedate.split('',10)}
                    </div>
                    <div className='_td' style={{width:"12%",textAlign:"end"}}>{item.nettotal}</div>
                    <div className='_td' style={{width:"30%",display:"flex", flexWrap:"wrap", justifyContent:"flex-end"}}>
                      <div style={{margin:"2px"}}>
                        <Button Value={<><FontAwesomeIcon icon={faEdit}/><p>Status</p></>} Action={()=>{
                          setShowStatusEdit(true);
                          setSelectedOrder(item.id);
                          setSelectedStatus(item.status);
                        }}/>
                        <Button Value={<><FontAwesomeIcon icon={faEdit}/><p>Department</p></>} Action={()=>{
                          setShowDepartmentEdit(true);
                          setSelectedOrder(item.id);
                          setSelectedDepartment(item.department);
                        }}/>
                        <Button Value={<><FontAwesomeIcon icon={faEdit}/><p>Edit</p></>} Action={()=>{
                          document.location.replace('/labadmin/orders/edit/'+item.id);
                        }}/>
                      </div>
                      <div style={{margin:"2px"}}>
                        <Button Value={<><FontAwesomeIcon icon={faPrint}/><p>Job card</p></>} Action={()=>{
                          window.open("/labadminreport/jobcard/"+item.id, "_blank", "noreferrer");
                        }}/>
                      </div>
                      <div style={{margin:"2px"}}>
                        <Button Value={<><FontAwesomeIcon icon={faEye}/><p>View</p></>} Action={()=>{
                          window.open("/labadminreport/jobcardnp/"+item.id, "_blank", "noreferrer");
                        }}/>
                      </div>
                      <div style={{margin:"2px"}}>
                        <Button Value={<><FontAwesomeIcon icon={faPrint}/><p>Lable</p></>} Action={()=>{
                          window.open("/labadminreport/label/"+item.id, "_blank", "noreferrer");
                        }}/>
                      </div>
                      <div style={{margin:"2px"}}>
                        <DeleteButton Action={()=>{
                          const confirmation = window.confirm('Are you sure you want to delete this order? This will also delete all its line items, notes, and tasks. This action cannot be undone.');
                          if(!confirmation) return;
                          const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                          Functions.Delete(item.id,setList,toast,toastid);
                        }}/>
                      </div>
                    </div>
                  </div>
                )
              })
            }
            {List.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index
